import { sudokuGrid } from "@lib/data"
import { useEffect } from "react"
import "./styles.css"

const sudokuLink = "https://sudokupad.app/n4qHMLbtTd"

export function Sudoku() {
  useEffect(() => {
    let scrollPos = 0
    let scrollMomentum = 0

    const isScrolledToBottom = () => {
      scrollMomentum = window.scrollY - scrollPos
      scrollPos = window.scrollY
      return window.innerHeight + window.scrollY >= document.body.offsetHeight
    }

    const executeWhenScrolledToBottom = () => {
      const el = document.querySelector<HTMLElement>(".sudoku")
      if (!el) return
      el.classList.add("bump")
      el.style.setProperty("--momentum", `${scrollMomentum}px`)

      window.setTimeout(() => {
        el.classList.remove("bump")
      }, 1000)
    }

    const handleScroll = () => {
      if (isScrolledToBottom()) executeWhenScrolledToBottom()
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div
      className="sudoku-container"
      data-id="sudoku-container"
    >
      <div
        className="sudoku"
        data-id="sudoku"
      >
        <a
          data-id="sudoku-link"
          href={sudokuLink}
          target="_blank"
          rel="noreferrer"
        >
          <div
            className="table"
            data-id="sudoku-grid"
          >
            {sudokuGrid.map((cell) => (
              <div
                className={`cell ${cell.row} ${cell.col}`}
                data-id={`sudoku-cell-${cell.row}-${cell.col}`}
                key={`${cell.row}-${cell.col}`}
              >
                {cell.value}
              </div>
            ))}
            <div className="dotted height-2 col-5 row-5" />
            <div className="dotted col-7 row-6" />
          </div>
        </a>
      </div>
    </div>
  )
}

export default Sudoku
